import * as styledComponent from 'styled-components';

const styled = styledComponent.default;
const css = styledComponent.css;

export default styled;
export { css };